/**
 * One recipe for the live lesson and booking screens, so they stop
 * inventing their own (native-app/design/DESIGN.md, docs/DESIGN_SYSTEM.md 8).
 *
 * The section header is Account's pairing, verbatim (AccountPage.tsx
 * SECTION_HEADER): Footnote 13/18 in sentence case at 0.6, never caps (lint:
 * local/no-caps), ABOVE its white section, 8 below it; explanation is a Footnote 8
 * under the section. Cards and grouped lists are white at radius 26, with
 * no shadow and no border (native DESIGN.md: 22 to 26 on cards and grouped
 * lists, one token per size; Ryan, 28 Oct). Small tiles inside them keep 12.
 */

export const SECTION_HEADER =
  'mb-2 text-[13px] leading-[18px] text-[rgba(60,60,67,0.6)]';

export const SECTION_FOOTNOTE = 'mt-2 text-[13px] leading-[18px] text-[rgba(60,60,67,0.6)]';

export const CARD = 'rounded-[26px] bg-white';

/**
 * A lesson screen's card with its padding (components.md 9, decision 156):
 * white, radius 26, 16 inside, no shadow, no border, on the grey page. It was
 * the async pane's 12 (Ryan, 29 Oct); the web-ported smaller radii retire on
 * these screens.
 */
export const PANE_CARD = 'rounded-[26px] bg-white p-4';

/** A 52-high row inside a CARD; the hairline above every row but the first is the caller's. */
export const ROW = 'flex min-h-[52px] items-center gap-3 py-3 pr-4';

export const ROW_TEXT = 'text-[17px] leading-[22px] tracking-[-0.43px] text-db-text-1';
export const ROW_VALUE = 'text-[17px] leading-[22px] tracking-[-0.43px] text-db-text-2';
export const FOOTNOTE = 'text-[13px] leading-[18px] text-db-text-2';

/** A text action, its target grown to 44 (GE-6). */
export const TEXT_ACTION =
  "ios-press relative cursor-pointer text-biscayne focus:outline-none focus-visible:underline " +
  "after:absolute after:-inset-x-2 after:-inset-y-3 after:content-['']";

/**
 * A text link that is a grouped row's whole action (Suggest a change, Request a Refund): Body 17 in Tint, the
 * row's 52 high, 16 in; the hairline above, when it follows another row, is the caller's (components.md 8, 9).
 */
export const ROW_LINK =
  'ios-press relative flex min-h-[52px] w-full cursor-pointer items-center pr-4 text-left text-[17px] leading-[22px] ' +
  'tracking-[-0.43px] text-biscayne focus:outline-none focus-visible:underline';

/**
 * The destructive text link at the foot (components.md 8: Cancel is a text action in the destructive color,
 * never a fill): Body 17 centred, a 44 target, the one red (LC-3).
 */
export const TEXT_ACTION_DESTRUCTIVE =
  'ios-press relative flex min-h-11 w-full cursor-pointer items-center justify-center text-[17px] leading-[22px] ' +
  'text-danger disabled:opacity-40 focus:outline-none focus-visible:underline';

/** A choice chip: 44 high, capsule, 8 apart in its row (`flex flex-wrap gap-2`). */
export const CHOICE_CHIP =
  'ios-press h-11 cursor-pointer rounded-[100px] px-4 text-[15px] leading-[20px] font-medium tabular-nums ' +
  'focus:outline-none focus-visible:ring-2 focus-visible:ring-db-accent/40 ';
export const CHOICE_ON = 'bg-biscayne text-white';
export const CHOICE_OFF = 'border border-[rgba(0,0,0,0.08)] bg-white text-db-text-1';
